import { Children } from 'react';
import { useTranslation } from 'react-i18next';

import Equipment from 'model/Equipment';
import { DEVICE_MODAL_TYPE } from 'types/enumType';
import { convertDeviceTypeToString } from 'util/commonUtil';

type DeviceTableProps = {
  type: DEVICE_MODAL_TYPE;
  list: Equipment[];
  deviceId: number;
  isAdmin: boolean;
  onSelect: (type: DEVICE_MODAL_TYPE, id: number) => void;
  onRegister: (type: DEVICE_MODAL_TYPE) => void;
  onClickDetail: (type: DEVICE_MODAL_TYPE, id: number) => void;
  isAvailableDevice: (type: DEVICE_MODAL_TYPE) => boolean;
  onPrint: (type: DEVICE_MODAL_TYPE) => void;
};

export default function DeviceTable({
  type,
  list,
  deviceId,
  isAdmin,
  onSelect,
  onRegister,
  onClickDetail,
  isAvailableDevice,
  onPrint,
}: DeviceTableProps) {
  const { t } = useTranslation();
  return (
    <section>
      <div className={'subtit'}>
        <p>{convertDeviceTypeToString(type)}</p>
        {/* {(type === DEVICE_MODAL_TYPE.PART ||
          type === DEVICE_MODAL_TYPE.AREA) && (
          <button
            className={'orange_white_btn'}
            type={'button'}
            onClick={() => onPrint(type)}
          >
            {t('device.qrCreate')}
          </button>
        )} */}
        {isAvailableDevice(type) && isAdmin && (
          <button
            className={'orange_white_btn'}
            type={'button'}
            onClick={() => onRegister(type)}
          >
            {t('device.regist')}
          </button>
        )}
      </div>
      <div className={'tbl-wrap'}>
        <table className={'tbl_ht01'}>
          <colgroup>
            <col width={'30%'} />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th>{t('device.code')}</th>
              <th>{`${convertDeviceTypeToString(type)} ${t('user.name')}`}</th>
            </tr>
          </thead>
          <tbody>
            {!list || list?.length === 0 ? (
              <tr>
                <td colSpan={2}>{t('conclusion.noData')}</td>
              </tr>
            ) : (
              Children.toArray(
                list.map((device) => (
                  <tr
                    className={device.id === deviceId ? 'active' : ''}
                    onClick={() => onSelect(type, device.id)}
                  >
                    <td>{device.code}</td>
                    <td className={'left flex'}>
                      {device.name}
                      {isAdmin && (
                        <button
                          type={'button'}
                          className={'orange_white_btn'}
                          onClick={(event) => {
                            event.stopPropagation();
                            onClickDetail(type, device.id);
                          }}
                        >
                          {t('button.edit')}
                        </button>
                      )}
                    </td>
                  </tr>
                )),
              )
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
